module.exports = __webpack_public_path__ + "static/media/21ECLAC43.4df2acd4.jpg";